import React from 'react'
import Pinteg from '../../components/Pinteg'
import Stories from '../../components/Stories'
import Cure from '../../components/Cure'

const BasketPage = () => {
    return (
        <Pinteg>
            <Stories />

            <Cure />
        </Pinteg>
    )
}

export default BasketPage
